import { ChatType, MessageType, MessageMaskType, MessageAuditStatus, AuditActionStatus } from '../constants/types';
import {
	FRIEND_LIST,
	// GroupChatSchema,
	// GROUP_CHAT_LIST,
	USER_LIST,
	UserSchema,
	FriendSchema,
	GROUP_CHAT_LIST,
	GroupChatSchema,
	MemberAvatarsSchema,
	MEMBER_AVATARS,
	GROUP_SEND_MSG,
	GroupSendMsgSchema,
} from './contactSchema';

export const VERSION_CONFIG = 'VersionConfig';
export type VERSION_CONFIG = typeof VERSION_CONFIG;

export interface VersionConfigSchema {
	sid?: number; // 当前sid，默认为0
	aid?: number; // 当前状态同步id,
	version?: number;
}

export const VersionConfig = {
	name: VERSION_CONFIG,
	bsonType: 'object',
	properties: {
		sid: 'int',
		aid: 'int?',
		version: 'int',
	},
};

// Latest Acks
export const LATEST_ACKS = 'LatestAcks';
export type LATEST_ACKS = typeof LATEST_ACKS;

export interface LatestAcksSchma {
	tid: string;
	mid: string;
}

export const LatestAcks = {
	name: LATEST_ACKS,
	properties: {
		tid: 'string',
		mid: 'string',
	},
};

// Meta
export const MESSAGE_META = 'MessageMeta';
export type MESSAGE_META = typeof MESSAGE_META;

export const MessageMeta = {
	name: MESSAGE_META,
	embedded: true,
	properties: {
		att: 'string?', // 艾特
		quoteMid: 'string?', // 引用的消息id
		quoteTid: 'string?', // 引用的消息tid
		quoteUid: 'string?', // 应用的消息发送者
		quoteUser: 'string?', // 引用的消息发送者昵称
		quoteCnt: 'string?', // 引用的消息内容
		quoteType: 'string?', // 引用的消息类型
		duration: 'string?', // 音频时长
		ratio: 'string?', // 未知
		thumbnail: 'string?', // 视频占位图
		isQuoteSelf: 'string?', // 是否引用自己的消息 0:flase   1:true
		width: 'string?', // 图片宽
		height: 'string?', // 图片宽
	},
};

// 消息表
// MsgId      string            `bson:"_id" json:"mid"`                   // 由 topicid:tmid 拼接而成 保证唯一
// TopicId    string            `bson:"tid" json:"tid,omitempty"`         // TopidId：g_topicid s_sys_userid 通过topicid的前缀 g_ s_ 区分单聊和群聊 系统给用户自动创建的会话;单聊是两个用户id排序后组合；
// TMsgId     int64             `bson:"tmid" json:"tmid,omitempty"`       // 会话单独的msgid
// ClientId   string            `bson:"cid" json:"cid,omitempty"`         // 客户端生成的唯一的消息Id，用于客户端消息去重
// Sender     int64             `bson:"sender" json:"sender,omitempty"`   // 发送方
// STime      int64             `bson:"stime" json:"stime,omitempty"`     // 发送时间 单位毫秒
// MsgType    string            `bson:"type" json:"type,omitempty"`       // 消息类型
// Content    string            `bson:"content" json:"content,omitempty"` // 消息正文内容
// Meta       map[string]string `bson:"meta" json:"meta,omitempty"`       // meta，消息属性客户端自行设置
// ExpireTime int64             `bson:"etime" json:"etime,omitempty"`     // 实效时间，过了这个时间消息批量拉取时跳过，单拉还是可以查询到，用于有时效的消息
export interface MessageSchema {
	mid: string;
	tid: string;
	sid?: number; // 拉取时的id； 同一批次拉取到的id相同
	tmid?: number;
	uid?: number;
	cid: number;
	sender: number;
	stime: number;
	type: MessageType;
	content: string;
	targetCnt?: number; // 目标数量
	readCnt?: number;
	encrypt?: number;
	mask?: MessageMaskType;
	meta: { [x: string]: any };
	etime?: number;
	atCnt?: number; // 艾特用户数
	atReadCnt?: number; // 被艾特用户已读数
	atUids?: number[]; // 艾特人的消息
	reported?: boolean; // 是否已经上报过，只存本地
	visible?: MessageAuditStatus; // 消息审核状态
	auditWord?: string; // 有需要审核的消息敏感词
	auditWordTip?: string; //敏感词提示内容
	auditRst?: AuditActionStatus;
	send_statue: string; //发送状态 0 发送中，1：发送失败。其他发送成功
	upload_statue?: string; //上传状态 0 上传中，1：上传失败。其他上传成功
	upload_path?: string; //上传图片/视频 本地路径
	thumbnailPath?: string; //视频 缩略图
	user?: UserSchema; // 消息转发的talk里需要
}

export const MESSAGE = 'Message';
export type MESSAGE = typeof MESSAGE;

export const Message = {
	name: MESSAGE,
	properties: {
		mid: 'string',
		tid: { type: 'string', indexed: true },
		tmid: 'int?',
		uid: 'int?',
		sid: 'int?',
		cid: 'string?',
		auditWord: 'string?',
		visible: { type: 'int', default: 0 },
		sender: 'int?',
		readCnt: 'int?',
		targetCnt: 'int?',
		stime: 'int',
		type: 'string',
		content: 'string',
		atCnt: 'int?',
		atReadCnt: 'int?',
		atUids: { type: 'int[]', default: [] },
		meta: MESSAGE_META,
		etime: 'int?',
		mask: { type: 'int', default: 0 },
		reported: 'bool?',
		auditRst: 'string?',
	},
	primaryKey: 'mid',
};

// TopicId    string `json:"tid"`             // 会话Id
// UserId     int64  `json:"uid"`             // 群聊就是创建人userId 单聊就是关联的对方userId
// Name       string `json:"name,omitempty"`  // 会话名
// ClientId   string `json:"cid,omitempty"`   // 客户端创建时填的id 创建人是自己时返回
// CreateTime int64  `json:"ctime,omitempty"` // 创建时间
// Type       string `json:"type"`            // 会话类型 群聊:group 单聊:single
// SyncId     int64  `json:"sid"`

export interface ChatListSchema {
	tid: string; // 会话Id
	uid?: number; // 群聊就是创建人userId 单聊就是关联的对方userId
	cid?: string; // 客户端创建时填的id 创建人是自己时返回
	ctime?: number; // 创建时间
	type: ChatType; // 会话类型 群聊:group 单聊:single
	sid?: number; // syncId
	utime?: number; // 更新时间
	name?: string; // 会话名称
	minMsgId?: string; // 后台查询的消息范围:最小的消息id
	maxMsgId?: string; // 后台查询的消息范围:最大的消息id
	latest_msg?: MessageSchema; // 最后一条消息
	perview_msg?: MessageSchema; // 用于预览的消息，可能为空
	unread?: number; // 未读消息数
	hasAt?: boolean; // 未读消息里面是否有@我的消息
	unAt?: number; // 未读@我的消息
	topUsers?: UserSchema[]; // 用来生成头像的前几个用户
	adminUids: number[]; // 如果是群会话的话，保存管理员id用来识别身份
	remark?: string; // 备注名
	latest_mid?: string; // 已读的最后一条消息
	hastopic?: boolean; // 当同步旧的状态时候可能会生成一个不包含数据的topicinfo，这个字段用来表示是否包含了topic数据而不是只有同步的状态
	tag?: string; // 会话标签
	isQuit?: boolean; // 是否已退出
	isDelete?: boolean; // 是否已删除
	delMaxMid?: string; // 删除时的最大消息id
	isMute?: boolean; // 是否免打扰
	isToTop?: boolean; //是否置顶
	draft?: string;
}

export interface MediaPreviewItem {
	type: MessageType;
	mid: string;
	index: number;
	currentIndex: number;
	content: string;
	upload_path?: string;
	thumbnailPath?: string;
}

export const CHAT_LIST = 'ChatList';
export type CHAT_LIST = typeof CHAT_LIST;

export const ChatList = {
	name: CHAT_LIST,
	properties: {
		tid: 'string',
		uid: 'int?',
		cid: 'string?',
		ctime: 'int?',
		type: 'string?',
		sid: 'int?',
		utime: 'int?',
		name: 'string?',
		unread: 'int?',
		unAt: 'int?',
		remark: 'string?',
		topUsers: {
			type: 'list',
			objectType: USER_LIST,
			default: [],
		},
		adminUids: {
			type: 'int[]',
			default: [],
		},
		minMsgId: 'string?',
		maxMsgId: 'string?',
		latest_msg: MESSAGE + '?',
		perview_msg: MESSAGE + '?',
		latest_mid: 'string?',
		hastopic: { type: 'bool', default: false },
		tag: 'string?',
		isDelete: 'bool?',
		isQuit: 'bool?',
		delMaxMid: 'string?',
		isMute: 'bool?',
		isToTop: 'bool?',
		draft: 'string?',
	},
	primaryKey: 'tid',
};

export type SchemaTypeMaps = {
	[MESSAGE]: MessageSchema;
	[CHAT_LIST]: ChatListSchema;
	[VERSION_CONFIG]: VersionConfigSchema;
	[MESSAGE_META]: { [x: string]: string };
	[LATEST_ACKS]: LatestAcksSchma;
	[USER_LIST]: UserSchema;
	[FRIEND_LIST]: FriendSchema;
	[GROUP_CHAT_LIST]: GroupChatSchema;
	[MEMBER_AVATARS]: MemberAvatarsSchema;
	[GROUP_SEND_MSG]: GroupSendMsgSchema;
	// [COLLEAGUE_LIST]: ColleagueSchema;
	// [GROUP_CHAT_LIST]: GroupChatSchema;
};
